export const environment = {
  production: false,
  apiURL: 'https://apidev.customerology.com/v1',
  environmentName: 'dev',
  APP_UUID: '575ea965-1c78-4e0b-9943-6b2bb68d7f53',
  loginApiKey:
    'bohlogYgOgSSPnMeSFHO5JG9HwL_r8UGyRkAAWyemQrrRmsjFDUlVMn1UPs1N78icy841T'
};
